import { Feature } from '@assetaccountant/api/models/feature';
import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';

/**
 * For use with authorizeFeature. Checks if the given integration type is a premium integration feature.
 *
 * @param integrationType - The integration type to check.
 *
 * @returns The premium integration feature type, or null if it is not a premium integration.
 */
export const isPremiumIntegrationFeature = (integrationType?: IntegrationType) => {
  return integrationType === IntegrationType.Sage ||
    integrationType === IntegrationType.MicrosoftDynamics
    ? Feature.PremiumIntegration
    : null;
};
